<div class="body-categoria py-5 px-2">
    <div class="box-content mx-auto mw-100 position-relative">
        <!-- <a mat-icon-button routerLink="/" class="position-absolute top-0 start-0">
            <mat-icon>arrow_back</mat-icon>
        </a> -->

        <img class="mw-100 d-block mx-auto margin-logo" width="30%" src="assets/img/logo.png" alt="">
        <p class="text-center fs-5">Tiendas QuinChau Motos</p>
        <p class="text-center fs-6">{{ globals.configuracion.front.listado.categoria_nombre }}</p>

        <a class="btn mb-3 cursor-pointer" (click)="seleccionarMayor()">Listado para Mayoristas</a>
        <a class="btn mb-3 cursor-pointer" (click)="seleccionarDetal()">Catálogo</a>
    </div>
</div>